__turbopack_context__.v({
  "aiChatWrapper": "cart-order-block-mobile-module-scss-module__j5jskq__aiChatWrapper",
  "block": "cart-order-block-mobile-module-scss-module__j5jskq__block",
  "button": "cart-order-block-mobile-module-scss-module__j5jskq__button",
  "buttonWrapper": "cart-order-block-mobile-module-scss-module__j5jskq__buttonWrapper",
  "total": "cart-order-block-mobile-module-scss-module__j5jskq__total",
});
